import * as React from 'react';
import { observer } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';

// Styles
const s = require('./OfflineArea.css');

// Props
interface IOfflineAreaProps {
    show: boolean;
    headline?: string;
    message?: string;
}

// Component
@observer
export class OfflineArea extends React.Component<IOfflineAreaProps, {}> {
    static get defaultProps(): IOfflineAreaProps {
        return {
            show: false,
            headline: 'You are currently offline.',
            message: 'We\'re attempting to reconnect with the server; however, the issue might be due to your network.',
        };
    }

    constructor(props) {
        super(props);
    }

    private get animationTime(): number { return 500; }

    public render() {
        return (
            <CSSTransitionGroup
                component="div"
                className={s.offlineArea}
                transitionName="slide"
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}
                transitionAppearTimeout={this.animationTime}
                transitionEnterTimeout={this.animationTime}
                transitionLeaveTimeout={this.animationTime}
            >
                {(this.props.show) && (
                    <div key="main-offline-bar" className={s.offlineBar}>
                        <p>
                            {(this.props.headline) && (
                                <strong>{this.props.headline}</strong>
                            )}

                            {(this.props.message) && (
                                <span>{this.props.message}</span>
                            )}
                        </p>
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Offline/OfflineArea.tsx